import { keyHandler } from 'utilities/dom';

export const KEY = {
    ENTER: 13,
    ESCAPE: 27,
    SPACE: 32,
    ARROW_UP: 38,
    ARROW_DOWN: 40,
}

/**
 * These attributes are applied to annotations meant to function as buttons,
 * that otherwise have their click handlers provided through config from studio
 */
export const accessibleAnnotation = {
    role: 'button',
    tabindex: '0'
};

export const focusable = {
    tabindex: "0"
};

export const disabledOverride = {
    tabindex: '-1',
    'aria-disabled': true 
}

export const accessible = (clickHandler, role = 'button') => {
    const props = {
        ...focusable,
        onKeyUp: keyHandler(KEY.ENTER, clickHandler),
        onKeyDown: keyHandler(KEY.SPACE, clickHandler),
        role: role
    };

    return props;
};

export const accessibleLabel = clickHandler => {
    const label = accessible(clickHandler);
    delete label.role;

    return label;
}

export const inaccessible = () => ({ tabIndex: '-1' });

export const accessibleContainer = {
    ['aria-relevant']: 'additions removals'
};

/**
 * Adds keyboard support to navigate menu buttons using arrow and escape keys.
 * @see {@link https://newsela.atlassian.net/wiki/spaces/AKB/pages/3288990514/Menu+buttons Accessibility Docs}
 * @param {Object} buttonRef - Button ref to store the DOM element that triggers the menu buttons
 * @returns {Object}
 */
export const accessibleMenuButtons = (buttonRef) => {
    const props = {
        onKeyDown: keyHandler([KEY.ARROW_DOWN, KEY.ARROW_UP, KEY.ESCAPE], function(e) {
            const element = e.target;
            const parentNode = element.parentNode;
            switch (e.keyCode) {
                case KEY.ARROW_UP:
                    element.previousElementSibling
                        ? element.previousElementSibling.focus()
                        : parentNode.children[parentNode.children.length - 1].focus();
                    break;
                case KEY.ARROW_DOWN:
                    element.nextElementSibling
                        ? element.nextElementSibling.focus()
                        : parentNode.children[0].focus();
                    break;
                case KEY.ESCAPE:
                    buttonRef.current.click();
                    buttonRef.current.focus();
                    break;
            }
        }),
    };

    return props;
}
